import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  inject,
} from '@angular/core';
import { InputComponentWrapper } from '../../constants';
import { ValidationService } from '../validation.service';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'conn-efan-input',
  templateUrl: './efan-input.component.html',
  styleUrls: ['./efan-input.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class EfanInputComponent implements OnInit {
  private validation = inject(ValidationService);

  @Input() submitted: boolean;
  @Input() inputModel: string;
  @Input() required: boolean;
  @Input() labelName: string;
  @Output() customBlur: EventEmitter<Event>;
  @Output() modelChanged: EventEmitter<InputComponentWrapper>;
  isValid: boolean;
  environment = environment;

  constructor() {
    this.inputModel = '';
    this.isValid = false;
    this.modelChanged = new EventEmitter<InputComponentWrapper>();
    this.customBlur = new EventEmitter<Event>();
  }

  ngOnInit(): void {
    this.isValid = this.validation.isEfanValid(this.inputModel, this.required);
  }

  changeModel(changedData: string) {
    if (changedData !== undefined) {
      this.inputModel = changedData;
      this.isValid = this.validation.isEfanValid(
        this.inputModel,
        this.required,
      );
      this.submitted = false;
      this.modelChanged.emit({
        inputText: changedData,
        isValid: this.isValid,
      } as InputComponentWrapper);
    }
  }

  emitBlur() {
    this.submitted = true;
    this.customBlur.emit(new Event('blur'));
  }
}
